<template>
    <div class="vue-onboarding__header">
        <div class="vue-onboarding__header__content flex justify-between text-lg">
            <span class="font-bold">{{ $t(title) }}</span>
            <feather-icon
                v-if="closeable"
                class="ml-3 cursor-pointer"
                icon="XIcon"
                svgClasses="h-6 w-6"
                @click="onClose" />
        </div>
        <slot name="progress">
        </slot>
    </div>
</template>

<script>
import FeatherIcon from "../Icons/FeatherIcon.vue";

export default {
    name: "vue-onboarding-header",

    components: {
        FeatherIcon,
    },

    props: {
        title: String,
        closeable: [Boolean, Function],

        // The props confirm closeable
        confirmable: {
            type: Boolean,
            default: false,
        },

        confirmText: {
            type: String,
            default: "",
        },

        confirmCallback: {
            type: Function,
            default: () => {}
        }

        // @emit('close')
    },

    methods: {
        onClose() {
            if (window.confirm('Bạn muốn tạm ngưng hướng dẫn cho người mới?')) {
                this.$emit('close');
            }
        },
    },
};
</script>

<style lang="scss">
.vue-onboarding__header {
    .vue-onboarding__header__content {
        border-radius: 5px 5px 0 0;
        background: #e9ecef;
        padding: 10.5px 16px;
        color: #212529;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.1);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/VueOnboarding/VueOnboardingHeader.vue